(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3584],{

/***/ 81903:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources",
      function () {
        return __webpack_require__(65501);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 65345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 88054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(65345),
    de: __webpack_require__(76419)
};


/***/ }),

/***/ 22205:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 62657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common,
    "section-try-for-free": __webpack_require__(33686),
    resources: __webpack_require__(2731)
};


/***/ }),

/***/ 71547:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(62657),
    de: __webpack_require__(22205)
};


/***/ }),

/***/ 65501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_fn_pipe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75833);
/* harmony import */ var _insightfulscience_contentful_Apps_Resources__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48474);
/* harmony import */ var _insightfulscience_atomic_react_r2_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93816);
/* harmony import */ var _insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46003);
/* harmony import */ var _insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93890);
/* harmony import */ var _src_SiteLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3918);
/* harmony import */ var _src_SectionTryForFree__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98106);
/* harmony import */ var _src_AppError__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38209);
/* harmony import */ var _locales_resources_page__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71547);
/* harmony import */ var _locales_resources_page__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_locales_resources_page__WEBPACK_IMPORTED_MODULE_10__);











const resourcesLayout = (param)=>{
    let { children  } = param;
    const [t] = (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__/* .useLocale */ .bU)("resources");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_src_SiteLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        hero: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_6__/* ["default"].OGP */ .ZP.OGP, {
                        image: t("META_IMAGE"),
                        imageSecureUrl: t("META_IMAGE_SECURE"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Twitter */ .ZP.Twitter, {
                        image: t("META_TWITTER_IMAGE"),
                        isImageBaseUrl: true
                    })
                ]
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_r2_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                id: "faqs",
                isBorderNone: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r2_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Title */ .Z.Title, {
                        children: t("USER_GUIDES")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r2_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Action */ .Z.Action, {
                        href: "https://support.snapgene.com/hc/en-us/categories/10304176221716",
                        size: "l",
                        weight: "bold",
                        children: t("MOST_POPULAR_QUESTIONS")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_SectionTryForFree__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        ]
    });
};
const ContentfulResourcesApp = (0,_insightfulscience_contentful_Apps_Resources__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    Layout: (0,_insightfulscience_shared_utils_fn_pipe__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(resourcesLayout, (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__/* .WithLocale */ ._t)({
        resources: (_locales_resources_page__WEBPACK_IMPORTED_MODULE_10___default())
    })),
    contentfulProps: {
        environment: "master",
        space: "d49zkrle08v9",
        accessToken: "892512d6e4c67cd995e1b1c2655b65f8c627ad3ff936c2ab3305fd173366b07f",
        proxy: null,
        filter: {
            include: 1
        }
    },
    pageProps: {
        brandCode: "sg",
        siteDomain: "https://www.snapgene.com"
    }
});
/* harmony default export */ __webpack_exports__["default"] = ((0,_insightfulscience_shared_utils_fn_pipe__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ContentfulResourcesApp, _src_AppError__WEBPACK_IMPORTED_MODULE_9__/* .withErrorHandling */ .b));


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 38209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ src_AppError; },
  "b": function() { return /* binding */ withErrorHandling; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ForceErrorHoC/index.js
var ForceErrorHoC = __webpack_require__(4354);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(76965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
;// CONCATENATED MODULE: ./src/AppError/Error400.js







const Error400 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("400");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("BAD_REQUEST")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/global-context/hook.js
var hook = __webpack_require__(63841);
;// CONCATENATED MODULE: ./src/utils/nav-hooks/useCurrentPath.js


/** @type {() => string} */ function useCurrentPath() {
    const context = (0,hook/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { asPath  } = router || context;
    return asPath;
}
/* harmony default export */ var nav_hooks_useCurrentPath = (useCurrentPath);

;// CONCATENATED MODULE: ./src/AppError/Error401.js








const Error401 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("401");
    const currentPath = nav_hooks_useCurrentPath();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_AUTHORIZED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: "".concat(routes/* default.logout */.ZP.logout, "?returnUrl=").concat(encodeURIComponent(currentPath)),
                        children: t("SIGN_IN")
                    }),
                    " ",
                    t("WITH_DIFFERENT_ACCOUNT"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js







const Error403 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("403");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_PERMITTED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error403 = (Error403);

;// CONCATENATED MODULE: ./src/AppError/Error404.js





const Error404 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("404");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_FOUND")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: t("DESC")
            })
        ]
    });
};
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js







const Error500 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("500");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("SOMETHING_WENT_WRONG")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error500 = (Error500);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js






const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "panel ".concat(color/* bgColorBlack */.ZH),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "".concat(color/* colorWhite */.A2, " px-5 py-5"),
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = (config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? ErrorDetails : ()=>null);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js + 1 modules
var Layout = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js + 3 modules
var SimpleTemplate = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js + 6 modules
var Header = __webpack_require__(38529);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./src/prerendered-logo.js
var prerendered_logo = __webpack_require__(25476);
;// CONCATENATED MODULE: ./src/AppError/ErrorLayout.js









/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Header */.Z.Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                    logo: prerendered_logo/* default */.ZP
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default.Body */.Z.Body, {
                className: color/* bgColorBlack2 */.vk,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTemplate/* default */.Z, {
                        children: children
                    }),
                    extra && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                        className: "pt-9 pt-9--md pb-18 pb-18--md",
                        children: extra
                    })
                ]
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types.node,
    extra: prop_types.node
};
/* harmony default export */ var AppError_ErrorLayout = (ErrorLayout);

// EXTERNAL MODULE: ./src/AppError/mapGraphQLErrors.js
var mapGraphQLErrors = __webpack_require__(20522);
// EXTERNAL MODULE: ./locales/errors-page/index.js
var errors_page = __webpack_require__(88054);
var errors_page_default = /*#__PURE__*/__webpack_require__.n(errors_page);
;// CONCATENATED MODULE: ./src/AppError/AppError.js














const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404
};
const AppError = (param)=>{
    let { error  } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorLayout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const appErr = (0,mapGraphQLErrors/* default */.ZP)(err);
    if (res) {
        res.statusCode = appErr.code;
    }
    if (appErr.code >= 500 && appErr.originalError != null) throw appErr.originalError;
    return {
        error: appErr.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_AppError = ((0,pipe/* default */.Z)(AppError, (0,i18/* WithLocale */._t)({
    resources: (errors_page_default())
})));

// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./src/graphql-local/unexpectedError/index.js + 3 modules
var unexpectedError = __webpack_require__(51041);
// EXTERNAL MODULE: ./src/sentry.js + 69 modules
var sentry = __webpack_require__(51720);
// EXTERNAL MODULE: ./src/utils/nav-hooks/useQueryString.js
var useQueryString = __webpack_require__(88046);
;// CONCATENATED MODULE: ./src/AppError/withErrorHandlingHoC.js










const withErrorHandlingHoC = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        const { data  } = (0,react_hooks_esm/* useQuery */.aM)(unexpectedError/* getUnexpectedError */.c);
        const asPath = nav_hooks_useCurrentPath();
        const query = (0,useQueryString/* default */.Z)();
        react.useEffect(()=>{
            if ((data === null || data === void 0 ? void 0 : data.unexpectedError) == null) return;
            (0,sentry/* notifySentry */.Yw)(ApplicationError/* default.of */.Z.of(data.unexpectedError), {
                asPath,
                query
            });
        }, [
            data === null || data === void 0 ? void 0 : data.unexpectedError
        ]);
        if (error == null && (data === null || data === void 0 ? void 0 : data.unexpectedError) == null) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_AppError, {
            error: error || ApplicationError/* default.of */.Z.of(data.unexpectedError)
        });
    };
    WithErrorHandling.propTypes = AppError_AppError.propTypes;
    WithErrorHandling.getInitialProps = (context)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context) : {};
            return (0,fn/* isPromise */.tI)(props) ? props.catch((err)=>AppError_AppError.getInitialProps({
                    ...context,
                    err
                })) : props;
        } catch (err) {
            return AppError_AppError.getInitialProps({
                ...context,
                err
            });
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ var AppError_withErrorHandlingHoC = (withErrorHandlingHoC);

;// CONCATENATED MODULE: ./src/AppError/index.js





const withErrorHandling = (0,fn/* compose */.qC)(AppError_withErrorHandlingHoC, config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? (0,ForceErrorHoC/* withForceError */.B)("throw") : fn/* idX */.Yr);
/* harmony default export */ var src_AppError = (AppError_AppError);


/***/ }),

/***/ 20522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I3": function() { return /* binding */ isNotFound; },
/* harmony export */   "_j": function() { return /* binding */ isNotAuthorized; }
/* harmony export */ });
/* unused harmony exports isGraphQLErrorIn, isBadRequest, isNotPermitted, isNetwork */
/* harmony import */ var _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66651);
/* eslint-disable no-nested-ternary, prettier/prettier */ 
const isGraphQLErrorIn = function() {
    for(var _len = arguments.length, codes = new Array(_len), _key = 0; _key < _len; _key++){
        codes[_key] = arguments[_key];
    }
    return (param)=>{
        let { graphQLErrors  } = param;
        return graphQLErrors && graphQLErrors.length && codes.includes(graphQLErrors[0].code);
    };
};
const isBadRequest = isGraphQLErrorIn(400, "INTERNAL_SERVER_ERROR");
const isNotAuthorized = isGraphQLErrorIn(401);
const isNotFound = isGraphQLErrorIn(400, 404);
const isNotPermitted = isGraphQLErrorIn(403);
const isNetwork = (param)=>{
    let { networkError  } = param;
    return networkError != null;
};
const mapGraphQLErrors = (error)=>isBadRequest(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 400) : isNotAuthorized(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 401) : isNotPermitted(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 403) : isNotFound(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 404) : isNetwork(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error) : _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"].of */ .Z.of(error);
/* harmony default export */ __webpack_exports__["ZP"] = (mapGraphQLErrors);


/***/ }),

/***/ 98106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19334);
/* harmony import */ var _insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73972);
/* harmony import */ var _insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18774);
/* harmony import */ var _insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46003);






const SectionTryForFree = ()=>{
    const [t] = (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__/* .useLocale */ .bU)("section-try-for-free");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Title */ .Z.Title, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    Tag: "span",
                    children: t("TRY_FREE_TEXT")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Action */ .Z.Action, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Link */ .Z.Link, {
                    href: "/free-trial",
                    size: "s",
                    className: "ml-auto mr-auto",
                    children: t("TRY_FREE_BUTTON_TEXT")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionTryForFree);


/***/ }),

/***/ 88046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89333);
/* harmony import */ var _global_context_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63841);




function useQueryString() {
    const context = (0,_global_context_hook__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { asPath  } = router || context;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(asPath), [
        asPath
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useQueryString);


/***/ }),

/***/ 2731:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"USER_GUIDES":"User Guides","MOST_POPULAR_QUESTIONS":"Find answers to the most popular questions ›","META_IMAGE":"/images/snapgene/resources/resourcesSocialMedia.png","META_IMAGE_SECURE":"/images/snapgene/resources/resourcesSocialMedia.png","META_TWITTER_IMAGE":"/images/snapgene/resources/resourcesSocialMedia.png"}');

/***/ }),

/***/ 33686:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TRY_FREE_TEXT":"Discover the most <b>user-friendly</b> molecular biology experience.","TRY_FREE_BUTTON_TEXT":"Try for Free"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,8610,7883,990,8125,2458,3918,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(81903); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);